import React from 'react';
import {
  WhatsappShareButton,
  FacebookShareButton,
  FacebookIcon,
  WhatsappIcon
} from 'react-share'
import Popover from 'material-ui/Popover';
import { Menu, MenuItem } from 'material-ui';

const title = 'Hey, check out Notifyi and find your perfectly matched course and college in India.\n'
const shareUrl = 'https://notifyi.in/signin'

export function StickyShare() {
  return (
    <div className="sticky-share">
      <small>Share</small>
      <FacebookShareButton
        url={shareUrl}
        quote={title}
      >
        <FacebookIcon width={40} height={40} />
      </FacebookShareButton>
      <WhatsappShareButton
        url={shareUrl}
        title={title}
      >
        <WhatsappIcon width={40} height={40} />
      </WhatsappShareButton>
    </div>
  )
}

export default class PopoverExampleSimple extends React.Component {


  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  handleClick = (event) => {
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    return (
      <div>
        <button className="share-btn w-100 mt-3" onClick={this.handleClick}>Share with friends</button>
        <Popover
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'left', vertical: 'top' }}
          onRequestClose={this.handleRequestClose}
        >
          <Menu>
            <FacebookShareButton
              className="w-100 text-left"
              url={shareUrl}
              quote={title}
            >
              <MenuItem primaryText="Facebook" />
            </FacebookShareButton>
            <WhatsappShareButton
              className="w-100 text-left"
              url={shareUrl}
              title={title}
            >
              <MenuItem primaryText="WhatsApp" />
            </WhatsappShareButton>
          </Menu>
        </Popover>
      </div>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/ShareButton/index.js
 **/